import React, { useState, useEffect } from 'react'
import { LPDesignCarouselSection } from '../../api/Types'
import DesignService from '../../../../api/Designs/Service'
import LandingPageSectionWrapper from '../common/LandingPageSectionWrapper'
import DynamicCallToAction from '../common/DynamicCallToAction'
import { DesignCardStatic as DesignCard } from '../../../designs/DesignCard'
import SlickCarousel from '../../../common/SlickCarousel'
import StartBuildingButton from '../../../assembly_card/StartBuildingButton'
import Loading from '../../../common/Loading'
import { Design } from '../../../../api/Designs/Types'

type Props = LPDesignCarouselSection

const LandingPageDesignCarousel: React.FC<Props> = ({ title, subtitle, designs, cta, style }) => {
  const [designList, setDesignList] = useState<ReadonlyArray<Design>>([])

  useEffect(() => {
    if (designs) {
      DesignService.fetchDesignList(designs, setDesignList)
    }
  }, [])

  function displayDesigns(designs: ReadonlyArray<DesignCard>) {
    const designCards = designs.map((design, index) => {
      return (
        <div key={index} className='design-card-wrapper'>
          <DesignCard {...design} />
        </div>
      )
    })
    const classNames = ['design-card-cta']
    if (style?.backgroundColor) {
      classNames.push(`bg-color-${style.backgroundColor}`)
    }
    designCards.splice(
      2,
      0,
      <div key={'cta'} className={classNames.join(' ')}>
        <div className='design-card-cta-body'>
          <p>We saved a spot for your project design.</p>
          <StartBuildingButton
            label='Get Started Now'
            className='button button-success button-lg new-assembly bring_to_sign_up_state'
          />
        </div>
      </div>
    )
    return designCards
  }

  return (
    <LandingPageSectionWrapper cssNamespace='design-carousel-section' style={style}>
      <div className='design-carousel-header'>
        {title && <h2>{title}</h2>}
        {subtitle && <p>{subtitle}</p>}
      </div>
      {designList.length ? (
        <SlickCarousel
          centerMode={true}
          infinite={true}
          slidesToShow={7}
          slidesToScroll={1}
          arrows={false}
          swipeToSlide={true}
          touchThreshold={100}
          responsive={[
            {
              breakpoint: 1800,
              settings: {
                slidesToShow: 6,
              },
            },
            {
              breakpoint: 1500,
              settings: {
                slidesToShow: 5,
              },
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 4,
              },
            },
            {
              breakpoint: 910,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                arrows: true,
                touchMove: false,
              },
            },
          ]}
        >
          {<>{displayDesigns(designList)}</>}
        </SlickCarousel>
      ) : (
        <Loading />
      )}
      {cta && (
        <div className='design-carousel-cta'>
          <DynamicCallToAction cta={cta} />
        </div>
      )}
    </LandingPageSectionWrapper>
  )
}

export default LandingPageDesignCarousel
